import api from '../../../helpers/api';

export const getPendingArtisanJobs = body =>
  api.post('job-staging/search', { ...body });

export const updatePendingArtisanJob = body =>
  api.post('job-staging', { ...body });

export const getSinglePendingArtisanProdcut = id =>
  api.get(`job-staging/${id}`);

export const deleteSinglePendingArtisanProdcut = id =>
  api.delete(`job-staging/${id}`);

export const moderateCreateSinglePendingArtisanJob = id =>
  api.post(`job-staging/moderate-create`, id);
export const moderateUpdateSinglePendingArtisanJob = id =>
  api.post(`job-staging/moderate-update`, id);
